import {z} from 'zod';

import type {FinancialProductPreferenceRefusalReason} from '../schemas/FinancialProductPreferenceRefusalReasonSchema';

type ConflictError = {code: FinancialProductPreferenceRefusalReason; message: string};

/** Only recognized 409 conflicts are recoverable; all other errors use generic handling. */
export const createFinancialProductPreferenceRefusalSchema = <Current, Input>(
  conflictBodySchema: z.ZodType<
    {errors: [ConflictError, ...ConflictError[]]; current: Current},
    z.ZodTypeDef,
    Input
  >
) =>
  z
    .object({status: z.literal(409), data: conflictBodySchema})
    .transform((conflict): {reason: FinancialProductPreferenceRefusalReason; current: Current} => ({
      reason: conflict.data.errors[0].code,
      current: conflict.data.current,
    }));
